export const WHITELIST_APPLY =
  //'https://asigna.gitbook.io/asigna/developers/connect-to-asigna-stacks-extension';
  'https://discord.com/invite/asigna';
